
    import './styles.scoped.css';
    export default {
  "dialog": "awsui_dialog_1d2i7_u0qf5_165",
  "modal-slide-up": "awsui_modal-slide-up_1d2i7_u0qf5_1",
  "awsui-motion-fade-in-0": "awsui_awsui-motion-fade-in-0_1d2i7_u0qf5_1",
  "refresh": "awsui_refresh_1d2i7_u0qf5_188",
  "awsui-motion-scale-popup": "awsui_awsui-motion-scale-popup_1d2i7_u0qf5_1",
  "root": "awsui_root_1d2i7_u0qf5_221",
  "awsui-motion-fade-in": "awsui_awsui-motion-fade-in_1d2i7_u0qf5_1",
  "hidden": "awsui_hidden_1d2i7_u0qf5_298",
  "focus-lock": "awsui_focus-lock_1d2i7_u0qf5_302",
  "position-top": "awsui_position-top_1d2i7_u0qf5_310",
  "position-center": "awsui_position-center_1d2i7_u0qf5_313",
  "small": "awsui_small_1d2i7_u0qf5_327",
  "medium": "awsui_medium_1d2i7_u0qf5_330",
  "large": "awsui_large_1d2i7_u0qf5_333",
  "x-large": "awsui_x-large_1d2i7_u0qf5_336",
  "xx-large": "awsui_xx-large_1d2i7_u0qf5_339",
  "custom-width": "awsui_custom-width_1d2i7_u0qf5_342",
  "max": "awsui_max_1d2i7_u0qf5_345",
  "breakpoint-xs": "awsui_breakpoint-xs_1d2i7_u0qf5_345",
  "custom-height": "awsui_custom-height_1d2i7_u0qf5_350",
  "container": "awsui_container_1d2i7_u0qf5_355",
  "custom-height-container": "awsui_custom-height-container_1d2i7_u0qf5_395",
  "content": "awsui_content_1d2i7_u0qf5_401",
  "no-paddings": "awsui_no-paddings_1d2i7_u0qf5_406",
  "custom-height-content": "awsui_custom-height-content_1d2i7_u0qf5_410",
  "header": "awsui_header_1d2i7_u0qf5_415",
  "header--text": "awsui_header--text_1d2i7_u0qf5_427",
  "footer": "awsui_footer_1d2i7_u0qf5_431",
  "footer--rounded": "awsui_footer--rounded_1d2i7_u0qf5_440",
  "dismiss-control": "awsui_dismiss-control_1d2i7_u0qf5_452",
  "modal-open": "awsui_modal-open_1d2i7_u0qf5_456"
};
  